import React, { useContext } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { LocationContext } from '@BUP/contexts/LocationContext'
import RoleRoute from '@BUP/routes/RoleRoute'
import DataPage from '@BUP/pages/Data'
import DiagnosticPage from '@BUP/pages/Data/diagnostic'
import CounselorDashboardPage from '@BUP/pages/Data/dashboard'

const DataNavigation = () => {
  const locale = useContext(LocationContext)
  const organizationCountry = locale?.country
  return (
    <Routes>
      {organizationCountry === 'Spain'
        ? (
          <Route path='*' element={<Navigate to='/' />} />
          )
        : (
          <>
            <Route
              path='/'
              element={<DataPage />}
            />
            <Route
              path='diagnostic'
              element={<DiagnosticPage />}
            />
            <Route
              path='dashboard'
              element={
                <RoleRoute name='DashboardPage'>
                  <CounselorDashboardPage />
                </RoleRoute>
            }
            />
            <Route
              path='*'
              element={<Navigate to='/' />}
            />
          </>
          )}
    </Routes>
  )
}

export default DataNavigation
